import { useStyles } from '@archipro-design/aria';
import * as S from './FeaturedCarousel.style';
import type { LoadingValue } from '@archipro-design/aria';

import { useRef } from 'react';
import { ArchizeenTile } from '@archipro-design/aria';
import type { AdvertCreative } from '@modules/adverts/type';
import type { FeaturedSlideProps } from '@modules/articles/type';
import { useAdEventHandler, useTracker } from '@archipro-website/tracker';
import { useLocalisation } from '@archipro-website/localisation';
import { getFormattedLocalisedDate } from '@modules/date-time/util/get-localised-date';
import { createLinkedComponentParams } from '~/utils/urlHelper';

interface FeaturedCarouselAdMobileProps {
    featuredSlide: FeaturedSlideProps;
    ad: AdvertCreative;
    imageLazyLoading: LoadingValue;
}

const FeaturedCarouselAdMobile: React.FC<FeaturedCarouselAdMobileProps> = ({
    featuredSlide,
    imageLazyLoading,
    ad,
}) => {
    const { css } = useStyles();

    const ref = useRef(null);
    const { onClick } = useAdEventHandler(ad, ref);
    const { localiseDate } = useLocalisation();
    const tracker = useTracker();

    const {
        ID: _ID,
        link,
        title,
        label,
        date,
        readTime,
        image,
        professionalID: _professionalID,
        hasVideo: _hasVideo,
        canEdit: _canEdit,
        bmEditorLink: _bmEditorLink,
        ...rest
    } = featuredSlide;

    return (
        <ArchizeenTile
            {...rest}
            ref={ref}
            {...createLinkedComponentParams(
                tracker,
                'Ad_CTAClick',
                link,
                {
                    libraryItemID: ad?.professional.id,
                    professionalID: ad?.professional.id,
                    professionalTitle: ad?.professional.title,
                },
                null,
                onClick
            )}
            prefetch="intent"
            className={css(S.MobileTile)}
            size={'medium'}
            variant="03"
            variables={{
                tilePadding: 0,
            }}
            image={{
                ...image,
                alt: title,
                loading: imageLazyLoading,
                sizes: '100vw',
            }}
            title={{
                children: title,
                maximumLines: 3,
            }}
            label={{
                children: label,
                variant: '06',
            }}
            date={{
                children: getFormattedLocalisedDate(localiseDate, date),
                variant: '06',
            }}
            readTime={{
                children: readTime,
                variant: '06',
            }}
            favouritePosition="card"
        />
    );
};

export default FeaturedCarouselAdMobile;
